var map = {
	"./anm-card.png": 566,
	"./app-install-icon.webp": 1513,
	"./arrow.png": 567,
	"./btn-blue-m-v2.png": 568,
	"./btn-blue-m.png": 569,
	"./btn-white-m-v2.png": 570,
	"./btn-white-m.png": 571,
	"./eeziepay.svg": 572,
	"./fcl.svg": 573,
	"./fpx-logo.svg": 574,
	"./game-blue.png": 575,
	"./game-img.png": 576,
	"./game-white.png": 577,
	"./global-language.svg": 578,
	"./ifm-logo.svg": 579,
	"./logo-anniversary.png": 580,
	"./logo-christmas.png": 581,
	"./logo-cny-dragon.png": 582,
	"./logo-cny.png": 583,
	"./logo-halloween.png": 584,
	"./logo-merdeka.png": 585,
	"./logo-mooncake.png": 586,
	"./logo-raya.png": 587,
	"./logo-uefa.png": 588,
	"./merchant-logo.png": 94,
	"./modal-bg.jpg": 589,
	"./number-bg.png": 590,
	"./pagcor.svg": 591,
	"./pool-bg.png": 592,
	"./side-bar-bg.png": 593,
	"./tether.svg": 594,
	"./x33-logo-wc.png": 595,
	"./x33-logo.png": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 774;